import { Field, Form, Formik, useFormikContext } from 'formik';
import React, { FC } from 'react';
import Modal from 'react-modal';
import { useLocale } from '../../../../contexts/localeContext';
import { TranslationKeys } from '../../../../contexts/TranslationKeys';
import closeIcon from '../../../../images/close.svg';
import { validateIpAddress } from '../../../../utilities/Validation';
import Label from '../../../label/label';

const initialValues = {
    ipAddress: '',
}

export const SingleIPSearchModal = ({ isOpen, onClose, handleOnSubmit }) => {
    const { resetForm } = useFormikContext<any>()
    const { translate } = useLocale();

    const closeWizard = () => {
        resetForm();
        onClose();
    };

    const onSave = async (values) => {
        const initialValues = {
            startIp: values.ipAddress,
            endIp: values.ipAddress,
        }
        handleOnSubmit(initialValues);
        onClose();
    }

    return <Modal
        isOpen={isOpen}
        ariaHideApp={false}
        onRequestClose={closeWizard}
        overlayClassName="flex w-screen position-float fixed top-0 left-0 h-screen bg-opacity-75 bg-white"
        className="bg-white border-none m-auto shadow select-none outline-none overflow-hidden" >
        <Formik
            enableReinitialize={true}
            initialValues={initialValues}
            onSubmit={onSave}>
            {({ errors }) => (
                <Form>
                    <div className={`w-full p-2 border-b flex flex-row items-center bg-sidemenu-focus text-white justify-between`}>
                        <div className="flex flex-row">
                            <p className="pl-3 font-bold font text-white">{translate.byKey(TranslationKeys.specificIP)}</p>
                        </div>
                        <img src={closeIcon} onClick={onClose} className="cursor-pointer mr-2" />
                    </div>
                    <div className="pt-3 pl-8 pr-0" style={{ width: '400px' }} >
                        <div className="flex flex-row mb-2 mr-6">
                            <div className="flex flex-col flex-1 pr-3">
                                <div className="flex flex-row justify-between" id='ipAddressLabelId'>
                                    <Label
                                        htmlFor="ipAddress"
                                        className="text-xs text-gray-600 mt-1" required>{translate.byKey(TranslationKeys.ipAddress)}:</Label>
                                    {errors.ipAddress ? <span className='text-red-600 text-xs'>{errors.ipAddress}</span> : null}
                                </div>
                                <Field id='ipAddressInputFieldId'
                                    type="text"
                                    name="ipAddress"
                                    className="flex flex-row items-center pr-2 pl-2 p-1 text-gray-800 text-sm w-full bg-gray-input"
                                    validate={(value) => validateIpAddress(value, translate, true)} />                                    
                            </div>
                        </div>
                    </div>
                    <div className="flex flex-row pb-3 pr-3 justify-end bg-white">
                        <div className="flex flex-row mt-4 mr-5">
                            <button
                                id='saveIpRangeBtnId'
                                className={`secondary secondary-enabled py-1 px-5  ${(errors.ipAddress) ? 'secondary-disabled cursor-not-allowed' : 'secondary-enabled'}`}
                                disabled={errors.ipAddress ? true : false}
                                type="submit">
                                {translate.byKey(TranslationKeys.scan)}
                            </button>
                        </div>
                    </div>
                </Form>
            )}
        </Formik>
    </Modal>
};
